import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'national_extraction_3'

export const dataPointDefinition = {
  retracedId: 'national_extraction_3',
  name: 'National Extraction',
  description:
    'National extraction refers to a person�s place of birth, ancestry or foreign origin. It is not the same as nationality. Discrimination based on national extraction may be directed against persons who are nationals of the country in which they are living, but who have acquired their citizenship by na',
  meta: {
    slcpMeta: {
      key: 'wt-dis-12x',
      number: 'WT-DIS-8-5',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'wt-dis-7',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[1],wt-dis-6,Yes',
      machineShowHide: '[1],wt-dis-6,1',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wt-dis-12x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 37110,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
